import endpoints from "../endpoints";

export default async function getTransferTypes() {
  let env = process.env.REACT_APP_ENV?.trim()
  return await (await fetch(endpoints.BUSINESS_BANKING.GET_TRANSFER_TYPES[env])).json();
}
